import { render, staticRenderFns } from "./logoComponent.vue?vue&type=template&id=fd3a0056&"
import script from "./logoComponent.vue?vue&type=script&lang=js&"
export * from "./logoComponent.vue?vue&type=script&lang=js&"
import style0 from "./logoComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports